export default "__VITE_ASSET__B_BFY027__"